export const FEATURE_TOGGLE = {
  GroupChat: 'v2.2402.06_group-chat',
  BillingAccountOrderCreation: 'v2.2402.20_billing-account-order-creation',
  WorkerRating: 'worker-rating',
  HideBrokenReports: 'hide-broken-reports',
  DownloadInvoicePdf: 'v2.2404.16_download-invoice',
  RegionFeature: 'v2.2404.16_region-zip-code-web',
  TwoDecimalHoursFeature: 'v2.2405.14_round_hours_to_two_decimal',
  AnnouncementRepliesQuotesFeature: 'v2.2405.14_announcement-replies-quotes',
  DisableBreakRule: 'v2.2405.14_disable_mandatory_break_for_short_shift',
  ClientAdminToDeleteAccount:
    'v2.2405.14_allow-customer-admins-to-delete-account',
  DashboardApprovalStatusFeature: 'v2.2405.28_needs-approval-status',
  SelectNearestAddressRateFeature: 'v2.2404.30_select_nearest_address_rate',
  AnnouncementExpiration: 'v2.2405.14_announcement-title-expiration',
  MarkupBasedPricingFeature: 'v2.2406.11_markup-based-pricing',
  SameWorkerAllShifts: 'v2.2401.09_same-worker-all-shifts',
  RemoveAddressCreationOnOrder:
    'v2.2405.28_remove-address-creation-during-order-creation',
  WorkerProfileRevamp: 'v2.2406.11_worker-profile-revamp',
  StaffingOrderCreation: 'v2.2406.25_worker-hire-and-invite-revamp',
  RemoveHolidayRates: 'v2.2407.02_remove-holiday-rates',
  LockBillRates: 'v2.2408.06_lock_bill_rates',
  HideDisabledBillingAccount: 'v2.2408.06_disable_billing_accounts',
};
